import { cn } from '@mdxui/primitives/lib/utils'
import type { ReactNode } from 'react'

export interface BlogHeaderProps {
  /** Blog title */
  title: string
  /** Blog description */
  description?: string
  /** Additional content (e.g., tag filter) */
  children?: ReactNode
  /** Additional className */
  className?: string
}

export function BlogHeader({ title, description, children, className }: BlogHeaderProps) {
  return (
    <header className={cn('pt-16 sm:pt-32 pb-8 sm:pb-12 px-6 flex flex-col gap-6 relative z-10', className)}>
      <div className="max-w-7xl mx-auto w-full">
        <div className="flex flex-col gap-2 text-center items-center">
          <h1 className="text-4xl lg:text-5xl font-semibold text-card-foreground text-balance">
            {title}
          </h1>
          {description && (
            <p className="text-muted-foreground text-sm md:text-base lg:text-lg max-w-2xl">
              {description}
            </p>
          )}
        </div>
      </div>
      {children}
    </header>
  )
}
